import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.tsx';
import { illegalNameCharsRegex } from '@sola/ark-core/utils/patterns.ts';
import { useNameMaxLengths } from '../../hooks/use-name-max-lengths.ts';
export type NameFieldsProps = {
  autoComplete?: boolean;
};
export const NameFields: React.FC<NameFieldsProps> = t0 => {
  const $ = _c(20);
  const {
    autoComplete: t1
  } = t0;
  const autoComplete = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["forms"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const {
    firstNameMaxLength,
    lastNameMaxLength
  } = useNameMaxLengths();
  let t3;
  if ($[1] !== t) {
    t3 = t("forms:contactFields.firstNameLabel");
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== autoComplete) {
    t4 = autoComplete && {
      autoComplete: "given-name"
    };
    $[3] = autoComplete;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== firstNameMaxLength || $[6] !== t3 || $[7] !== t4) {
    t5 = <InputField label={t3} name="firstName" {...t4} required={true} maxLength={firstNameMaxLength} illegalCharsRegex={illegalNameCharsRegex} />;
    $[5] = firstNameMaxLength;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("forms:contactFields.lastNameLabel");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== autoComplete) {
    t7 = autoComplete && {
      autoComplete: "family-name"
    };
    $[11] = autoComplete;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== lastNameMaxLength || $[14] !== t6 || $[15] !== t7) {
    t8 = <InputField label={t6} name="lastName" {...t7} required={true} maxLength={lastNameMaxLength} illegalCharsRegex={illegalNameCharsRegex} />;
    $[13] = lastNameMaxLength;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};